import React, { useMemo } from 'react';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import DetailsColumn from '../../Common/DetailsComponents/detailsColumn';
import RelatedAssets from '../../AssetPage/OverviewTab/RelatedAssets/relatedAssets';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import ComboBoxEditor from 'infrastructure/js/components/editors/ComboBoxEditor/comboBoxEditor';
import Parse from 'infrastructure/js/components/controls/controlsParse';
import {enumTypes, getEnumLabel, getEnumValue} from '../../../utils/enumHelper';
import Link from '../../Common/Layout/Link/link';
import {navigationStates} from '../../../enums/navigationStates';
import {getEditorDataConverter} from 'infrastructure/js/utils/editorHelper';
import AlertPopover from 'infrastructure/js/components/popover/AlertPopover/alertPopover';
import {isLotAccessible} from '../../../utils/assetHelper';

import './overviewTab.scss';


const convertEditorDataToServerData = getEditorDataConverter('lot');

function getLotStatusOptions() {
  return[
    {value: getEnumValue(enumTypes.LOT_STATUS)('IN_PREPARATION'), label: getEnumLabel(enumTypes.LOT_STATUS)('IN_PREPARATION')},
    {value: getEnumValue(enumTypes.LOT_STATUS)('READY_FOR_INSPECTION'), label: getEnumLabel(enumTypes.LOT_STATUS)('READY_FOR_INSPECTION')},
    {value: getEnumValue(enumTypes.LOT_STATUS)('PASSED_INSPECTION'), label: getEnumLabel(enumTypes.LOT_STATUS)('PASSED_INSPECTION'), isDisabled: true},
    {value: getEnumValue(enumTypes.LOT_STATUS)('FAILED_INSPECTION'), label: getEnumLabel(enumTypes.LOT_STATUS)('FAILED_INSPECTION'), isDisabled: true},
    // {value: getEnumValue(enumTypes.LOT_STATUS)('LOCKED_FOR_SHIPMENT'), label: getEnumLabel(enumTypes.LOT_STATUS)('LOCKED_FOR_SHIPMENT'), isDisabled: true},
  ]
}

export default function OverviewTab({ sData, actions }) {
  const loading = sData.get('loading');
  const lotDetails = sData.get('lotDetails');

  const labels = useMemo(() => createLabelHelper('mat.assetpage.overview.details.'), [])

  const handleAssetEditInPlaceSubmit = (editorSubmitData) => {
    if (!editorSubmitData) {
      return;
    }
    let serverDataValue = convertEditorDataToServerData(editorSubmitData);

    if (serverDataValue === undefined) {
      return;
    }

    let newData = {};
    newData[editorSubmitData.fieldName] = serverDataValue;

    actions.updateLot(lotDetails.id, newData);

  }

  const getStatusAlert = (asset) => {
    if (asset.statusValidationMessage) {
      return (
        <AlertPopover
          popoverType={'error'}
          popoverComponent={<div>{asset.statusValidationMessage}</div>}
        />
      )
    }
    return null;
  }

  const renderStatusEditor = (asset) => {
    if (!asset?.id) {
      return null;
    }

    let option = Parse.findOptionById(
      asset.status,
      getLotStatusOptions()
    );

    let displayValue = option ? option.label : getEnumLabel(enumTypes.LOT_STATUS)(asset.status);

    return (
      <ComboBoxEditor
        id="status"
        name="status"
        value={option}
        displayValue={displayValue}
        handleSubmit={handleAssetEditInPlaceSubmit}
        options={getLotStatusOptions()}
        alert={getStatusAlert(asset)}
        editable={isLotAccessible(asset?.status)}
      />
    );
  };


  const renderCoCLink = (asset) => {
    if (!asset.coc) {
      return null;
    }
    if (asset.status === getEnumValue(enumTypes.LOT_STATUS)('IN_PREPARATION')) {
      return <span>{asset.coc?.name || ''}</span>;
    }
    return (
      <div className='location-value-cell'>
        <Link
          label={asset.coc?.name ?? ''}
          id={asset.coc?.id ?? null}
          type={navigationStates.COC}
          className="link-details"
        />
      </div>
    );
  };

  const columnsData = [
    [
      {
        label: labels.get('batchNo'),
        className: lotDetails.relatedAssets?.batchNumbers?.length ? 'batch-number-row' : '',
        body: (
          <>
            {lotDetails.relatedAssets?.batchNumbers?.map((batchNo) => (
              <div key={batchNo}>{batchNo}</div>
            ))}
          </>
        ),
      },
      {
        label: labels.get('createdat'),
        body: <span>{DateTimeHelper.FormatDateObjectToDayMonth(lotDetails.createdDate)}</span>,
      },
      {
        label: labels.get('createdby'),
        body: <span>{lotDetails.createdByUser}</span>,
      },
    ],
    [
    ...(PermissionManager.isCoCEnabled() ?
      [
        {
          label: labels.get('lotStatus'),
          body: renderStatusEditor(lotDetails),
        },
        {
          label: labels.get('coc'),
          body: renderCoCLink(lotDetails),
        },
      ] : []),
    ]
  ];

  let columns = columnsData.map((column, index) => {
    return <DetailsColumn key={'lot' + index} rows={column} />;
  });

  return (
    <div className="lot-overview-tab">
      <div className="lot-details">
        <div className="lot-details-section">
          {columns}
          {/*<DetailsColumn rows={rows} />*/}
          {/*<DetailsColumn rows={[]} />*/}
        </div>
      </div>
      <RelatedAssets componentAssets={lotDetails?.relatedAssets?.assets} />
      {loading && <Overlay.Loading />}
    </div>
  );
}
